import { useEffect } from "react";

const BASE_URL = "https://newideaarchitect.com";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (url) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
};

/**
 * Oldalankénti SEO: cím, leírás, canonical és Open Graph frissítése.
 * @param {string} title - böngésző fül / kereső cím
 * @param {string} description - meta leírás (~150 karakter)
 * @param {string} path - útvonal a canonical URL-hez (pl. "/munkaink")
 * @param {boolean} noindex - true esetén a keresők nem indexelik (pl. admin, köszönőoldal)
 */
export const useSEO = (title, description, path = "/", noindex = false) => {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", title);
    setMeta("property", "og:url", `${BASE_URL}${path}`);
    setCanonical(`${BASE_URL}${path}`);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);
};
